"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutCustomerMonitoringEventsRequestToJSON = exports.PutCustomerMonitoringEventsRequestFromJSONTyped = exports.PutCustomerMonitoringEventsRequestFromJSON = exports.instanceOfPutCustomerMonitoringEventsRequest = void 0;
const Event_1 = require("./Event");
const UserDetails_1 = require("./UserDetails");
/**
 * Check if a given object implements the PutCustomerMonitoringEventsRequest interface.
 */
function instanceOfPutCustomerMonitoringEventsRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "batchId" in value;
    isInstance = isInstance && "events" in value;
    isInstance = isInstance && "userDetails" in value;
    return isInstance;
}
exports.instanceOfPutCustomerMonitoringEventsRequest = instanceOfPutCustomerMonitoringEventsRequest;
function PutCustomerMonitoringEventsRequestFromJSON(json) {
    return PutCustomerMonitoringEventsRequestFromJSONTyped(json, false);
}
exports.PutCustomerMonitoringEventsRequestFromJSON = PutCustomerMonitoringEventsRequestFromJSON;
function PutCustomerMonitoringEventsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'batchId': json['batchId'],
        'events': (json['events'].map(Event_1.EventFromJSON)),
        'userDetails': (0, UserDetails_1.UserDetailsFromJSON)(json['userDetails']),
    };
}
exports.PutCustomerMonitoringEventsRequestFromJSONTyped = PutCustomerMonitoringEventsRequestFromJSONTyped;
function PutCustomerMonitoringEventsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'batchId': value.batchId,
        'events': (value.events.map(Event_1.EventToJSON)),
        'userDetails': (0, UserDetails_1.UserDetailsToJSON)(value.userDetails),
    };
}
exports.PutCustomerMonitoringEventsRequestToJSON = PutCustomerMonitoringEventsRequestToJSON;
